import { render, staticRenderFns } from "./order_homepage.vue?vue&type=template&id=69e354e6&scoped=true&"
import script from "./order_homepage.vue?vue&type=script&lang=js&"
export * from "./order_homepage.vue?vue&type=script&lang=js&"
import style0 from "./order_homepage.vue?vue&type=style&index=0&id=69e354e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e354e6",
  null
  
)

export default component.exports